
<ng-container *ngIf="!!lineGraph">
    <div echarts [options]="options" class="chart-container2"  [autoResize]="false" (chartInit)="onChartInit($event)"></div>
</ng-container>